import { render, staticRenderFns } from "./NewEditItem.vue?vue&type=template&id=1d6ac186&scoped=true&"
import script from "./NewEditItem.vue?vue&type=script&lang=js&"
export * from "./NewEditItem.vue?vue&type=script&lang=js&"
import style0 from "./NewEditItem.vue?vue&type=style&index=0&id=1d6ac186&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ac186",
  null
  
)

export default component.exports